import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { ViewWorkDialogAssignmentAttempt } from 'src/app/Elearning-Models';

@Component({
  selector: 'app-assignment-attempts-view-work-dialog',
  templateUrl: './assignment-attempts-view-work-dialog.component.html',
  styleUrls: ['./assignment-attempts-view-work-dialog.component.scss']
})
export class AssignmentAttemptsViewWorkDialogComponent implements OnInit {

  
  valueUpdated = new EventEmitter<any>();
  
  cancelButtonString: string;
  okButtonString: string;
  
  assignmentID: number;
  assignmentName: string;
  studentName: string;
  studentID: number;

  dataReceived: boolean = false;

  assignmentAttempts: ViewWorkDialogAssignmentAttempt[] = [];




  constructor(
    public dialogRef: MatDialogRef<AssignmentAttemptsViewWorkDialogComponent>,
    private router: Router,
    private APIService: IAPIService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.cancelButtonString = data.cancelString;
    this.okButtonString = data.okString;
    this.assignmentID = data.assignmentID;
    this.assignmentName = data.assignmentName;
    this.studentName = data.studentName;
    this.studentID = data.studentID;
   }

  ngOnInit(): void {

    this.APIService.GetAssignmentAttemptsForViewWorkDialog(this.studentID, this.assignmentID).subscribe(result => {
      if(result){
        this.assignmentAttempts = result; 
      }

      this.dataReceived = true;
    });

  }

  onViewWork(attemptID: number){
    this.router.navigate([environment.rootPath + 'ViewWork'], {
      queryParams: {
        AttemptID: attemptID,
        AssignmentID: this.assignmentID,
        AssignmentName: this.assignmentName,
        StudentName: this.studentName
      },
    });

    this.onSubmit();
  }


  onSubmit(){
    this.valueUpdated.emit(true);
    this.dialogRef.close();
  }

}
